import { useQuery } from "@tanstack/react-query";

import { getFieldVerifications } from "services";

import { DEFAULT_CACHE, GET_FIELD_VERIFICATIONS } from "consts";

import { GetFieldVerificationsQuery } from "models";

export const useGetFieldVerifications = ({ farmId, search, filter, excludeRedzoneGeometry, onlySoilPlus3 }: GetFieldVerificationsQuery) =>
  useQuery({
    queryKey: [GET_FIELD_VERIFICATIONS, farmId, search, filter, excludeRedzoneGeometry, onlySoilPlus3],
    queryFn: () => getFieldVerifications({ farmId, search, filter, excludeRedzoneGeometry, onlySoilPlus3 }),
    enabled: !!farmId,
    gcTime: DEFAULT_CACHE.gcTime / 24,
    staleTime: DEFAULT_CACHE.staleTime / 24,
  });
